export const CODE_PREFIX = 'GC-';
export const CODE_PATTERN = /^GC-[A-Z0-9]{6}$/;

/** Keeps a box in GC-XXXXXX form however the code is typed or pasted (gc7k2qxm, GC 7K2QXM, GC-GC-7K2QXM…). */
export function asOrderCode(value) {
  const raw = String(value ?? '')
    .toUpperCase()
    .replace(/[^A-Z0-9-]/g, '');
  let rest = raw.replace(/^(GC-)+/, '');
  if (rest === raw) rest = /^G?C?$/.test(raw) ? '' : raw.replace(/^GC(?=[A-Z0-9]{6}$)/, '');
  return `${CODE_PREFIX}${rest.replace(/-/g, '').slice(0, 6)}`;
}
